import React from "react";
import { Link } from "react-router";
import styled from "styled-components";

type PaginationComponentProps = {
  numbers: Array<number>;
  currentPageNumber: number;
  url: string;
  params?: string;
};

const PaginationStyle = styled.ol`
  display: flex;
  flex-wrap: nowrap;
  column-gap: 5px;
  justify-content: center;
  margin: 10px 0;
  padding: 0;
`;

const PaginationLiStyle = styled.li<{ $background: string }>`
  list-style: none;

  a {
    align-items: center;
    background: ${(props) => props.$background};
    border-radius: 25px;
    color: white;
    display: flex;
    font-size: 14px;
    justify-content: center;
    text-decoration: none;
    width: 40px;
    height: 40px;
  }
`;

const Pagination: React.FC<PaginationComponentProps> = ({
  numbers,
  currentPageNumber,
  url,
  params,
}) => {
  return (
    <PaginationStyle>
      {numbers.map((number) => {
        if (!number) return;
        return (
          <PaginationLiStyle
            key={number}
            $background={currentPageNumber === number ? "#393432" : "#d1d1d1"}
          >
            <Link to={url + "?" + `${params || ""}` + "&page=" + number}>
              {number}
            </Link>
          </PaginationLiStyle>
        );
      })}
    </PaginationStyle>
  );
};

export default Pagination;
